// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon-1Cn5E","iconTwitter":"iconTwitter-27EHp icon-1Cn5E","iconFacebook":"iconFacebook-13qcX icon-1Cn5E","title":"title-3CHPN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/friends/_inviteFriends.css
// module id = 1198
// module chunks = 1